// extracted by mini-css-extract-plugin
module.exports = {"orderIcon":"Order_style_orderIcon__OP6Du","disable":"Order_style_disable__3WtmX"};